import { Sparkles } from "lucide-react";

import { type DateInput, toDate } from "@/shared/datetime";
import { formatUtcRange } from "@/shared/time";

import { RobotoPrincipalUnderlineLink } from "../principal";

import styles from "./EntityHeader.module.css";

/** The meta line's mark for a record an action or invocation created. */
export function AutomationIcon() {
  return <Sparkles />;
}

/** Who created the record, linked: a user's email, or an action's ID in mono. */
export function CreatedBy({
  createdBy,
  isUser,
}: {
  createdBy: string;
  isUser: boolean;
}) {
  return (
    <span className={isUser ? undefined : styles.mono}>
      <RobotoPrincipalUnderlineLink principal={createdBy} />
    </span>
  );
}

/**
 * A recorded range on one line, in UTC, in tabular figures, as
 * {@link formatUtcRange} writes it, with the exact instants on hover.
 */
export function UtcRange({ start, end }: { start: DateInput; end: DateInput }) {
  const from = toDate(start);
  const to = toDate(end);
  if (from === null || to === null) {
    return null;
  }
  return (
    <span
      className={styles.rangeTime}
      title={`${from.toISOString()} → ${to.toISOString()}`}
    >
      {formatUtcRange(from, to)}
    </span>
  );
}
